export const getConvertedValue = (value, unitTo) => {
  value = parseFloat(value);
  if (isNaN(value)) return "";
  const conversionMap = {
    inches: 0.393701,
    cm: 2.54,
    cms: 2.54,
  };

  return (value * conversionMap[unitTo]).toFixed(1);
};

export const sanitizeNAN = (text) => {
  return isNaN(text) ? "" : text;
};
